import { useMe } from "../../hooks/useMe";
import { useMySteps } from "../../hooks/personaQueries";

export function ApproverHome() {
  const { data: me } = useMe();
  const { data: steps, isLoading } = useMySteps("awaiting_review");
  const packets = steps ?? [];

  return (
    <div className="main-inner" data-testid="approver-home">
      <div className="greet-row">
        <span className="greet">Good afternoon, {firstName(me?.user.displayName)}.</span>
        <span className="greet-date">DECISIONS AWAITING YOU</span>
      </div>
      <div className="subgreet">
        <div className="section-eyebrow">YOUR REVIEW QUEUE</div>
        <div className="lede">
          <b>{packets.length} decision packet{packets.length === 1 ? "" : "s"}</b> open.
        </div>
      </div>

      {isLoading ? (
        <Skeleton />
      ) : packets.length === 0 ? (
        <EmptyState message="No decisions awaiting your review." />
      ) : (
        <div className="ap-packets">
          {packets.map((p) => (
            <div key={p.id} className="ap-packet">
              <div className="ap-packet-h">
                <span className="ap-stakes-pill gray">decision</span>
                <span style={{ flex: 1 }} />
                <span className="ap-age">{p.playTitle}</span>
              </div>
              <div className="ap-packet-t">{p.title}</div>
              <div className="ap-packet-a">
                <button type="button" className="btn primary">
                  Approve
                </button>
                <button type="button" className="btn">
                  Reject
                </button>
                <button type="button" className="btn">
                  Send back with note
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function firstName(displayName?: string): string {
  if (!displayName) return "there";
  return displayName.split(/\s+/)[0] ?? displayName;
}

function Skeleton() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {[0, 1].map((i) => (
        <div
          key={i}
          style={{ height: 140, borderRadius: 10, background: "var(--bg-soft)", opacity: 0.6 }}
        />
      ))}
    </div>
  );
}

function EmptyState({ message }: { message: string }) {
  return (
    <div
      style={{
        padding: 24,
        textAlign: "center",
        color: "var(--text-3)",
        border: "1px dashed var(--border)",
        borderRadius: 8,
        fontSize: 13,
      }}
    >
      {message}
    </div>
  );
}
